import { useState } from 'react';

import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { DataFeedsModals, DataFeedsModalStateType, useModalContext } from 'utils/contexts/modal';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';

import { IndexHeaderActionContainer, WideInputSearch } from './IndexPage.styled';
import { useFilterContext } from '../contexts/Filter';
import { useTranslations } from '../hooks/useTranslations';
import { emptyFeedData } from '../constants';

const ids = {
  btnCreate: 'df-create-data-feed-btn',
  inputSearch: 'df-search-data-feeds-input',
};

export const testIds = {
  btnCreate: ids.btnCreate,
  inputSearch: ids.inputSearch,
};

// Warning: adding props to this component can cause focus issues with the search input

export const IndexHeaderActions = () => {
  const { t } = useTranslations();
  const { searchQuery, setSearchQuery } = useFilterContext();
  const { showModal } = useModalContext<DataFeedsModalStateType>();
  const [searchInputValue, setSearchInputValue] = useState(searchQuery);

  useDebouncedEffect(() => setSearchQuery(searchInputValue), [searchInputValue], {
    skipEffectOnMount: true,
    debounceTimeout: 500,
  });

  return (
    <IndexHeaderActionContainer>
      <WideInputSearch
        data-test={testIds.inputSearch}
        handleClear={() => setSearchInputValue('')}
        id={ids.inputSearch}
        placeholder={t('input.search.placeholder')}
        onChange={setSearchInputValue}
        value={searchInputValue}
      />
      <Button
        data-test={testIds.btnCreate}
        id={ids.btnCreate}
        onClick={() =>
          showModal({
            modal: DataFeedsModals.CreateFeed,
            dataFeed: emptyFeedData,
          })
        }
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.PRIMARY}
      >
        <AddNew16 />
        {t('button.newFeed')}
      </Button>
    </IndexHeaderActionContainer>
  );
};

export default IndexHeaderActions;
